module.exports = __webpack_public_path__ + "img/IMG-20210316-WA00222.ad21fd8f.jpg";